namespace TabAurous.Inventory {
    export interface ReOrderDetailsRow {
        DetailsId?: number;
        TransId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        ProductTypeCode?: string;
        CategoryCode?: string;
        SubCategoryCode?: string;
        ProductCode?: string;
        AttributeId?: number;
        ProductId?: number;
        UOM?: number;
        FixedCode?: string;
        Minimum0?: number;
        Maximum0?: number;
        Minimum1?: number;
        Maximum1?: number;
        Minimum2?: number;
        Maximum2?: number;
        Validate?: boolean;
    }

    export namespace ReOrderDetailsRow {
        export const idProperty = 'DetailsId';
        export const localTextPrefix = 'Inventory.ReOrderDetails';
        export const lookupKey = 'Inventory.ReOrderDetails';

        export function getLookup(): Q.Lookup<ReOrderDetailsRow> {
            return Q.getLookup<ReOrderDetailsRow>('Inventory.ReOrderDetails');
        }
        export const deletePermission = 'Inventory:ReOrder:Delete';
        export const insertPermission = 'Inventory:ReOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:ReOrder:Edit';

        export declare const enum Fields {
            DetailsId = "DetailsId",
            TransId = "TransId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            ProductTypeCode = "ProductTypeCode",
            CategoryCode = "CategoryCode",
            SubCategoryCode = "SubCategoryCode",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            ProductId = "ProductId",
            UOM = "UOM",
            FixedCode = "FixedCode",
            Minimum0 = "Minimum0",
            Maximum0 = "Maximum0",
            Minimum1 = "Minimum1",
            Maximum1 = "Maximum1",
            Minimum2 = "Minimum2",
            Maximum2 = "Maximum2",
            Validate = "Validate"
        }
    }
}
